<template>
  <div v-if="currentResource || livePreviewHash">
    <resources />
  </div>
</template>
<script setup lang="ts">
import { useRoute } from 'vue-router';
import { useAsyncData } from '#app';
import { onBeforeUnmount } from 'vue';
import Resources from '~/components/templates/Resources.vue';
import { definePageMeta, useEntryPasswordProtected } from '#imports';
import { useResourcesStore } from '~/stores/resources';
import { useLivePreview } from '~/composables/live-preview';
import { DEFAULT_LAYOUT } from '~/constants/layout';

const route = useRoute();
const resourceStore = useResourcesStore();
const { checkEntry, redirect } = useEntryPasswordProtected();
const { getLivePreviewHashFromPath, handleLivePreviewMode } = useLivePreview();
const livePreviewHash = getLivePreviewHashFromPath(route);

const { data: currentResource } = await useAsyncData(
  route.path,
  () => {
    return resourceStore.loadSingle(route.params.slug as string);
  },
  {
    watch: [route],
  }
);

if (!currentResource.value) {
  const { data: isProtectedPage } = await useAsyncData(
    `path-protected-${route.path}`,
    async () => {
      return checkEntry(route.path, 'resources');
    },
    {
      watch: [route],
    }
  );

  if (isProtectedPage.value) {
    await redirect('resources', livePreviewHash);
  } else {
    if (!livePreviewHash) {
      showError({
        statusCode: 404,
        statusMessage: 'Page not found',
      });
    }
  }
}

resourceStore.setResource(currentResource.value);

onMounted(() => {
  handleLivePreviewMode(livePreviewHash);
});

onBeforeUnmount(() => {
  if (route.name === 'resources-slug') {
    return;
  }
  resourceStore.setCurrentResource(null);
});

definePageMeta({
  key: (route) => route.fullPath,
  pageType: 'resource',
  layout: DEFAULT_LAYOUT,
});
</script>
